<template>
  <section class="content">
    <main class="keyfeat-container">
      <ul>
        <li
          v-for="(keyFItem, keyFIdx) in keyFeatList"
          :key="keyFIdx"
          :style="{
            'background-color': keyFItem.fillColor
          }"
        >
          <div
            :class="[
              'keyfeat-item',
              keyFIdx % 2 == 0 ? 'keyfeat-item--left' : 'keyfeat-item--right'
            ]"
          >
            <img
              :src="keyFItem.imgURL"
              :alt="keyFItem.imgAlt"
              class="keyfeat-item-img"
            />
            <div class="keyfeat-item-info_container">
              <h3 class="keyfeat-item-info_container-title">
                {{ keyFItem.infoSummary }}
              </h3>
              <span
                class="split_line"
                :style="{
                  'background-color': keyFItem.splitLineColor
                }"
              ></span>
              <p class="keyfeat-item-info_body">{{ keyFItem.info }}</p>
            </div>
          </div>
        </li>
      </ul>
    </main>

    <section class="mobile">
      <div
        class="outer"
        v-for="(item, index) in contentMobile"
        :style="{ background: item.color }"
        :key="index"
      >
        <p class="info">
          {{ item.value }}
        </p>
        <img :src="item.img" alt="" />
      </div>
    </section>
  </section>
</template>

<script>
export default {
  name: "Feature",
  data() {
    return {};
  },
  metaInfo() {
    if(this.srouce != 'main'){
      return {
        title: "ToTok Features – Unlimited free calling and conference calls",
        meta: [
          {
            Description:
              "ToTok supports unblocked free calling, video filters, group calls, 10000-person group chats and much more.",
          },
          { property: "og:title", content: "ToTok Features – Unlimited free calling and conference calls" },
          { property: "og:url", content: "https://totok.ai/features" },
          { property: "og:type", content: "website" },
          {
            property: "og:image",
            content: "https://static.totok.ai/pic/preview/free_unblocked_call.png",
          },
          {
            property: "og:description",
            content:
              "ToTok supports unblocked free calling, video filters, group calls, 10000-person group chats and much more.",
          },
          { property: "og:site_name", content: "ToTok" },
        ],
      };
    }
    
  },
  props: {
    keyFeatList: {
      type: Array,
      required: true
    },
    srouce:{
      type:String
    }
  },
  methods:{
    t(d,ar){
      if(this.$route.query.lang == "ar"){
        if(ar != undefined) return ar;
        else return d;
      } else {
        return d;
      }
    }
  },
  computed: {
    // keyFeatList() {
    //         return [
    //             {
    //                 imgURL: require('../assets/img/pic_features_1.png'),
    //                 imgAlt:this.$t('keyFeat1'),
    //                 infoSummary:this.$t('keyFeat1'),
    //                 info:this.$t('keyFeat1-desc'),
    //                 fillColor: "#f9f1f8",
    //                 splitLineColor:"#5b81d6"
    //             },
    //             {
    //                 imgURL: require('../assets/img/pic_features_2.png'),
    //                 imgAlt:this.$t('keyFeat2'),
    //                 infoSummary:this.$t('keyFeat2'),
    //                 info:this.$t('keyFeat2-desc'),
    //                 fillColor: "#f8f8f8",
    //                 splitLineColor:"#3fbc89"
    //             },
    //             {
    //                 imgURL: require('../assets/img/pic_features_3.png'),
    //                 imgAlt:this.$t('keyFeat3'),
    //                 infoSummary:this.$t('keyFeat3'),
    //                 info:this.$t('keyFeat3-desc'),
    //                 fillColor: "#e7ebf3",
    //                 splitLineColor:"#d83076"
    //             },
    //             {
    //                 imgURL: require('../assets/img/pic_features_4.png'),
    //                 imgAlt:this.$t('keyFeat4'),
    //                 infoSummary:this.$t('keyFeat4'),
    //                 info:this.$t('keyFeat4-desc'),
    //                 fillColor: "#faf4ed",
    //                 splitLineColor:"#ea8f39"
    //             },

    //         ]
    //     },
    contentMobile() {
      return [
        {
          value: this.$t("tips"),
          img: require("../assets/img/2x/pic_features_1.png"),
          color: "#e4f4ff"
        },
        {
          value: this.$t("platform"),
          img: require("../assets/img/2x/pic_features_2.png"),
          color: "#ffe3b0"
        },
        {
          value: this.$t("voiceinfo"),
          img: require("../assets/img/2x/pic_features_3.png"),
          color: "#f2f2ff"
        },
        {
          value: this.$t("adfree"),
          img: require("../assets/img/2x/pic_features_4.png"),
          color: "#e9f4ea"
        }
      ];
    }
  }
};
</script>

<style scoped lang="stylus">
@media only screen and (min-width: 701px) {
.content{
    .mobile {
        display: none;
    }
    .keyfeat-container{
        .keyfeat-item{
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 500px;
            width: 800px;
            margin: 0 auto;
            overflow-y: hidden;
            .keyfeat-item-img{
                height: 480px;
                margin-top: 120px;
            }
            .keyfeat-item-info_container{
                    margin-left: 140px;
                    .keyfeat-item-info_container-title{
                        font-size: 35px;
                        font-weight: 300;
                        width: 408px;
                        letter-spacing: 1px;
                        line-height: 1.2;
                    }
                    .split_line{
                        display: block;
                        background-color: #5b81d6;
                        width: 30px;
                        height: 3px;
                        margin: 15px 0px;
                    }
                    .keyfeat-item-info_body{
                        width: 346px;
                        font-size: 14px;
                        font-weight: 300;
                        line-height: 18px;
                        letter-spacing 1px;
                        font-family: "sofiapro-regular", "Calibri Light", "Helvetica Neue", Roboto, sans-serif;
                    }
                }
        }
        .keyfeat-item--left{
            flex-flow: row;
            .keyfeat-item-info_container{
                margin-left: -22px;
            }
        }
        .keyfeat-item--right{
            flex-flow: row-reverse;
            .keyfeat-item-info_container{
                margin-left: 60px;
            }
        }
    }
}
}
@media only screen and (max-width: 701px) {
.content{
    .mobile {
        display: none;
    }
    .keyfeat-container{
        .keyfeat-item{
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            flex-flow: wrap-reverse;
            height: 680px;
            .keyfeat-item-img{
                    height: 440px;
                margin-top: 10px;
            }
            .keyfeat-item-info_container{
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                    align-items: center;
                    height: 170px;
                    text-align: center;
                    .keyfeat-item-info_container-title{
                        width: 288px;
                        height: 48px;
                        font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                        font-size: 24px;
                        color: #262626;
                    }
                    .split_line{
                        width: 40px;
                        height: 3px;
                        margin-top: 16px;
                        background-color: #5b81d6;
                    }
                    .keyfeat-item-info_body{
                        width: 315px;
                        height: 42px;
                        font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                        font-size: 16px;
                        line-height: 21px;
                        color: #262626b3;
                    }
                }
        }

    }
}
}
</style>
